module.exports = __webpack_public_path__ + "img/pt-5.8b2e271c.jpg";